import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { useContext } from '../Context';

export default function Form({ closePopup, affiliate }) {
  const [loader, setLoader] = useState(false);
  const { dispatch, actions } = useContext();

  const successInvite = () => {
    swal({
      title: 'Invite Sent!',
      text: '',
      html: true,
      type: 'success',
      showCancelButton: false,
      confirmButtonText: 'Close',
      closeOnConfirm: true,
    });
  };

  const onInvite = () => {
    setLoader(true);
    actions.invite(dispatch, affiliate.id, () => {
      setLoader(true);
      closePopup();
      successInvite();
    });
  };

  return (

    <div className="text-center mt50 mb30">
      <Button
        disabled={loader}
        className="mr5 ml5 width-120  btn-outline"
        bsStyle="primary"
        onClick={closePopup}
      >
        Cancel
      </Button>

      <Button
        disabled={loader}
        bsStyle="primary"
        className="mr5 ml5 width-120"
        onClick={() => onInvite()}
      >
        {loader ? 'Please, wait ...' : 'Invite'}
      </Button>
    </div>

  );
}
